// extracted by mini-css-extract-plugin
module.exports = {"button":"OrdersSetAsViewedButton_button__1zJod","button-ltr":"OrdersSetAsViewedButton_button-ltr__XN8EI"};